import { gql, useMutation } from "@apollo/client";
import { Spin, Radio } from "antd";
import React, { useEffect, useState } from "react";
import { ACCEPT_OFFER } from "../../../graphql/mutations/offers";
import bountyIcon from "../../../imgs/bounty.svg";
import ConnectIcon from "../../../imgs/connection.svg";
import { ChatIcon, OfferIcon, RightArrow } from "../SvgIcons/SvgIcons";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import SubmitIcon from "../../../imgs/Submiticon.svg";
import { PayPalButton } from "react-paypal-button-v2";

const PurchaseModal = ({
  firstName,
  lastName,
  fullName,
  bountyId,
  offerId,
  handleCancel,
  demandPrice,
  status,
  company,
  bountyType,
}) => {
  const [loader, setLoader] = useState(false);
  const [acceptOffer] = useMutation(gql(ACCEPT_OFFER));
  const [current, setCurrent] = useState(0);
  const strapiRes = useSelector((state) => state.strapiRes);
  const [amount, setAmount] = useState(0);
  const [cardPay, setCardPay] = useState(false);

  const handleAmmount = () => {
    let calc = demandPrice * (10 / 100);
    let tenPercentAmount = demandPrice + calc;
    setAmount(tenPercentAmount);
  };

  useEffect(() => {
    handleAmmount();
  }, [demandPrice]);

  const history = useHistory();

  const next = () => {
    setCurrent(current + 1);
  };

  const handleSubmit = () => {
    if (bountyId && offerId) {
      setLoader(true);
      acceptOffer({
        variables: {
          bountyId: bountyId,
          offerId: offerId,
          paymentType: cardPay ? "account" : "card",
        },
      }).then((res) => {
        setLoader(false);
        // handleCancel();
        next();
      });
    }
  };

  const steps = [
    {
      content: (
        <Spin spinning={loader} className="loading">
          <div className="bounty-modal-wrapper submit-wrapper">
            <div className="center-content">
              <img src={bountyIcon} alt="bountyIcon" className="icon" />
              <h2 className="heading">
                @{firstName}
                {lastName} <img src={ConnectIcon} alt="ConnectIcon" />{" "}
                {bountyType === "company" ? company : fullName}
              </h2>
              <p>
                Once you purchase an intro, you can arrange the introduction.
                Your bounty is on hold until introduction is marked as
                completed.
              </p>
              <p className="notes">
                Other offers still stand until you mark introduction as
                completed. If you choose to cancel introduction after purchase,
                there will be a cancellation fee of $10.
              </p>
            </div>
            <div className="row m-0 w-100">
              <div className="col-6 pl-0">
                <button className="btn-style cancel" onClick={handleCancel}>
                  Cancel
                </button>
              </div>
              <div className="col-6 pr-0">
                <button className="btn-style" onClick={() => next()}>
                  Purchase intro
                </button>
              </div>
            </div>
            <p className="notes mt-1">
              By continuing, you agree to the terms and privacy policy.
            </p>
          </div>
        </Spin>
      ),
    },
    {
      content: (
        <div className="purchase-intro-modal">
          <div className="modal-card-top">
            <div>
              <h2 className="heading">Purchase intro</h2>
              <p>
                You’ll be charged ${demandPrice} <span>+10% service fee</span>
              </p>
            </div>
            <OfferIcon />
          </div>
          <div className="radio-buttons">
            <label>Payment method</label>
            {/* <div className="checkbox-container"> */}
            {/* <Checkbox checked={cardPay} onClick={() => setCardPay(!cardPay)}> */}
            {/* <div> */}
            {/* <p>Account Balance</p> */}
            {/* <p className="error-msg">
                    Insufficient balance.{' '}
                    <a>
                      Add funds now
                      <RightArrow />
                    </a>
                  </p> */}
            {/* </div> */}
            {/* <h2 className="small-heading">${strapiRes.balance}</h2> */}
            {/* </Checkbox> */}
            {/* </div> */}
            <Radio.Group name="radiogroup" defaultValue={0}>
              <Radio checked={cardPay} onClick={() => setCardPay(!cardPay)}>
                <div className="checkbox-container">
                  <div>
                    <p>Account Balance</p>
                    {strapiRes.balance > 0 ? null : (
                      <p className="error-msg">
                        Insufficient balance.{" "}
                        <a onClick={() => history.push("/account")}>
                          Add funds now
                          <RightArrow />
                        </a>
                      </p>
                    )}
                  </div>
                  <h2 className="small-heading">${strapiRes.balance}</h2>
                </div>
              </Radio>
            </Radio.Group>
            <PayPalButton
              amount={amount}
              style={{color: 'white'}}
              onSuccess={handleSubmit}
              // onSuccess={paymentSuccess}
              catchError={(err) => {
                console.log('error in payment', err);
              }}
              options={{
                disableFunding: 'credit',
                clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
              }}
            />
            {/* <div className="checkbox-container">
              <Checkbox>
                <div>
                  <p>Apple Pay</p>
                </div>
                <img src={appleIcon} />
              </Checkbox>
            </div> */}
            {/* <div className="checkbox-container">
              <Checkbox>
                <div>
                  <p>PayPal</p>
                </div>
                <img src={PayPalIcon} />
              </Checkbox>
            </div> */}
            {/* <div className="checkbox-container mb-0"> */}
            {/* <PayPalButton  /> */}
            {/* <Checkbox>
                <div>
                  <p>Credit Card</p>
                </div>
                <div className="d-flex align-items-center">
                  <img src={masterIcon} className="mr-2" />
                  <img src={visaIcon} />
                </div>
              </Checkbox> */}
            {/* </div> */}
            {/* <div className="credit-card-info">
                <div className="card-list">
                  <div className="card-icon">
                    <img src={masterIcon} />
                  </div>
                  <p>Master Card ending 4902</p>
                </div>
                <div className="card-list">
                  <div className="card-icon">
                    <img src={visaIcon} />
                  </div>
                  <p>Visa Card ending 8882</p>
                </div>
                <div className="card-list">
                  <div className="card-icon">
                    <AddIcon />
                  </div>
                  <p>Add new card </p>
                </div>
              </div> */}
            {/* <div className="add-card-info">
              <div className="input-field">
                <label>Name on card</label>
                <input type="text" placeholder="Tim Jordan Smith" />
              </div>
              <div className="input-field">
                <label>Card number</label>
                <input type="text" placeholder="**** **** **** 1223" />
              </div>
              <div className="row m-0">
                <div className="input-field col pl-0">
                  <label>Expiry date</label>
                  <input type="text" placeholder="11 / 22" />
                </div>
                <div className="input-field col">
                  <label>CVV</label>
                  <input type="text" placeholder="***" />
                </div>
                <div className="input-field col pr-0">
                  <label>Zip code</label>
                  <input type="text" placeholder="90120" />
                </div>
              </div>
            </div> */}
          </div>
          <p className="policy-text">
            Other offers still stand until you mark introduction as completed.
            By continuing, you agree to the <a>terms</a> and{" "}
            <a>privacy policy</a>.
          </p>
          <div className="btn-row">
            <div className="col pl-0">
              <button className="btn-style" onClick={handleCancel}>
                Cancel
              </button>
            </div>
            <div className="col p-0">
              <button className="btn-style" onClick={handleSubmit}>
                Purchase intro
              </button>
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <Spin spinning={loader} className="loading">
          <div className="bounty-modal-wrapper submit-wrapper">
            <div className="center-content">
              <img src={SubmitIcon} alt="bountyIcon" className="icon" />
              <h2 className="heading">
                {firstName}
                {lastName} <img src={ConnectIcon} alt="ConnectIcon" />{" "}
                {bountyType === "company" ? company : fullName}
              </h2>
              <p>You have purchased an intro!</p>
            </div>
            <div className="row m-0 w-100">
              <div className="col-6 pl-0">
                <button className="btn-style cancel" onClick={handleCancel}>
                  Back to Offer
                </button>
              </div>
              <div className="col-6 pr-0">
                <button
                  className="btn-style"
                  onClick={() => history.push("/chat")}
                >
                  <ChatIcon />
                  Arrange Intro
                </button>
              </div>
            </div>
            <p className="notes mt-1">
              By continuing, you agree to the terms and privacy policy.
            </p>
          </div>
        </Spin>
      ),
    },
  ];

  return <div className="steps-content">{steps[current]?.content}</div>;
};

export default PurchaseModal;
